export default __webpack_public_path__ + "static/media/api.6ed9e8a0.svg";